import { render, staticRenderFns } from "./classrooms.vue?vue&type=template&id=d4938d46&"
import script from "./classrooms.vue?vue&type=script&lang=js&"
export * from "./classrooms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports